import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/store";
import styles from "./diagram.module.css";
import { setDiagramView } from "../store/gridSlice";
import { useTranslation } from "react-i18next";
import mixpanel from "mixpanel-browser";

const ChangeDiagramView = () => {
  const dispatch = useDispatch();
  const { selectedView } = useSelector((state: RootState) => state.grid);
  const { t } = useTranslation();
  const { form } = useSelector((state: RootState) => state.pattern.meta);
  return (
    <div className={styles.toolContainer}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
        }}
      >
        {form !== "freeform" && (
          <>
            <button
              className={`${styles.toolButton}
          ${selectedView === "model" ? styles.contrast : ""}`}
              onClick={() => {
                dispatch(
                  setDiagramView(selectedView !== "model" ? "model" : "grid")
                );
              }}
            >
              {form === "sweater" ? t("draw.model") : t("draw.sock")}
            </button>
            <hr />
          </>
        )}
        <button
          id="intro-knit-sample"
          onClick={() => {
            mixpanel.track("knit_sample");
            dispatch(setDiagramView(selectedView !== "fell" ? "fell" : "grid"));
          }}
          className={`${styles.toolButton}
            ${selectedView === "fell" ? styles.contrast : ""}`}
        >
          {t("draw.knit sample")}
        </button>
      </div>
    </div>
  );
};

export default ChangeDiagramView;
